import { colors } from './colors';
import { ThemeConfig } from 'antd';

export const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.PRIMARY,
    colorFillSecondary: colors.SECONDARY,
    borderRadius: 6,
    colorText: colors.BLACK,
  },
  components: {
    Layout: {
      headerBg: colors.PRIMARY,
      headerHeight: '70px',
      bodyBg: colors.BG_COLOR,
      lightSiderBg: colors.WHITE,
      lightTriggerBg: colors.WHITE,
      lightTriggerColor: colors.PRIMARY,
    },
    Menu: {
      itemBg: colors.TRANSPARENT,
      fontSize: 18,
      itemSelectedBg: colors.PRIMARY,
      itemSelectedColor: colors.WHITE,
      itemHoverBg: colors.PRIMARY_HOVER,
      itemHoverColor: colors.WHITE,
    },
    Typography: {
      titleMarginBottom: 0,
      titleMarginTop: 0,
    },
    Button: {
      fontSize: 14,
      borderRadius: 6,
      colorText: colors.WHITE,
      colorPrimary: colors.PRIMARY,
      colorPrimaryText: colors.WHITE,
      defaultBg: colors.DARKER_GREY_COLOR,
    },
    Table: {
      headerBg: colors.DARKER_GREY_COLOR,
      headerColor: colors.BLACK,
      headerBorderRadius: 8,
      colorBgContainer: colors.TRANSPARENT,
      borderColor: colors.COLOR_BORDER,
      headerSplitColor: colors.COLOR_BORDER,
      cellPaddingInline: 16,
      cellPaddingBlock: 8,
    },
    Badge: {
      colorText: colors.PRIMARY,
    },
    Input: {
      colorPrimaryHover: colors.PRIMARY,
      activeBorderColor: colors.PRIMARY,
      activeShadow: colors.SECONDARY,
    },
    DatePicker: {
      colorPrimaryHover: colors.PRIMARY,
      activeBorderColor: colors.PRIMARY,
      activeShadow: colors.SECONDARY,
    },
    Progress: {
      defaultColor: colors.PRIMARY,
      colorFillSecondary: colors.DARKER_GREY_COLOR,
    },
  },
};
